export default __webpack_public_path__ + "static/media/37.60e72324.png";